module.exports = __webpack_public_path__ + "icon-map-black.svg?9d967bd63f5ed757cbfa1a6a6c52c703";